import { imgUrl, imgDims } from "@/lib/img";

export const ProductImage = ({ maison, reference, suffix, alt, className = "", eager = false }) => {
  const { width, height } = imgDims(suffix);
  const ratio = suffix === "plan-serre" ? "16/9" : "4/5";
  return (
    <img
      src={imgUrl(maison, reference, suffix)}
      alt={alt}
      width={width}
      height={height}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      className={className}
      style={{ aspectRatio: ratio, objectFit: "cover", width: "100%", height: "auto" }}
    />
  );
};
